var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row mt-3" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("icon-view", {
            staticClass: "mb-3",
            attrs: {
              gradient: "",
              icon: "fa fa-dollar-sign",
              "icon-background": "#FF7058",
              "icon-color": "#fff",
              title: "Adjudicación por Cifra de Cuenta"
            }
          }),
          _vm.billInfo.billingPurchaseOrderNumbers.length == 0 &&
          !_vm.isApprovedStatus
            ? _c(
                "div",
                { staticClass: "mb-4" },
                [_c("custom-result-not-found")],
                1
              )
            : _vm._e(),
          !_vm.onlyShowVoucher
            ? _c(
                "div",
                { staticClass: "row mb-3 bg-secondary-13 py-3 ml-2 rounded" },
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      !_vm.contractInfo.isDirectPayment &&
                      !_vm.hasDebtPurchaseOrderNumber
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col d-flex align-items-center" },
                              [
                                _vm._m(0),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-gray-6 font-16 font-weight-normal mr-2"
                                  },
                                  [_vm._v(" PO ID: ")]
                                ),
                                _vm.showChoosePO && !_vm.isOldBilling
                                  ? _c("custom-drop-down", {
                                      staticClass: "w-50",
                                      attrs: {
                                        clearable: false,
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.purchaseOrders,
                                        placeholder: "Seleccione"
                                      },
                                      on: { input: _vm.onPOIDChangeHandler },
                                      model: {
                                        value: _vm.value.purchaseOrderId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value,
                                            "purchaseOrderId",
                                            $$v
                                          )
                                        },
                                        expression: "value.purchaseOrderId"
                                      }
                                    })
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-black font-16 font-weight-normal"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              `${_vm.billInfo.selectedPurchaseOrderId} (${_vm.billInfo.selectedPurchaseOrderBudgetYear})`
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col d-flex align-items-center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-gray-6 font-16 font-weight-normal mr-2"
                                  },
                                  [_vm._v(" Voucher ID: ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-black font-16 font-weight-normal"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("empty")(
                                            _vm.billInfo.voucherNumber
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col d-flex align-items-center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-gray-6 font-16 font-weight-normal mr-2"
                                  },
                                  [_vm._v(" Estatus: ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-black font-16 font-weight-normal"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("empty")(
                                            _vm.billInfo.voucherStatus
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-auto d-flex align-items-end justify-content-end"
                              },
                              [
                                _vm.cantPrintDistributionNumber && _vm.paymentId
                                  ? _c(
                                      "action-button",
                                      {
                                        attrs: {
                                          i: "fas fa-print",
                                          variant: "success"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit(
                                              "print-payment-distribution",
                                              _vm.paymentId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " Imprimir Distribución de Pago "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm.showUpdateVoucherStatus &&
                            (!_vm.voucherTrackingInfo ||
                              !_vm.voucherTrackingInfo.cashClearedDate)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-auto d-flex align-items-end justify-content-end"
                                  },
                                  [
                                    _vm.canUpdateSifde
                                      ? _c("action-button", {
                                          attrs: {
                                            i: "fas fa-redo-alt",
                                            variant: "outline-success"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "on-update-voucher-status",
                                                _vm.billInfo.voucherNumber
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-3 d-flex align-items-center"
                              },
                              [
                                _vm._m(1),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-gray-6 font-16 font-weight-normal mr-2"
                                  },
                                  [_vm._v(" Número de Voucher: ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.canEditVoucherInfo,
                                        expression: "canEditVoucherInfo"
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "validation-observer",
                                      {
                                        ref: "voucherNumberRef",
                                        attrs: { novalidate: "" }
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-input", {
                                                      staticClass:
                                                        "custom-input__extended w-100",
                                                      attrs: {
                                                        "custom-error-msg":
                                                          "El voucher es requerido.",
                                                        error: errors[0]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.voucherNumber,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.voucherNumber = $$v
                                                        },
                                                        expression:
                                                          "voucherNumber"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            587783483
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                !_vm.canEditVoucherInfo &&
                                (_vm.voucherNumber ||
                                  _vm.billInfo.voucherNumber)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-black font-16 font-weight-normal"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm.voucherNumber ??
                                                  _vm.billInfo.voucherNumber
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col d-flex justify-content-end align-items-center"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-gray-6 font-16 font-weight-normal mr-2"
                                  },
                                  [_vm._v(" Fecha de Voucher: ")]
                                ),
                                _c(
                                  "validation-observer",
                                  {
                                    ref: "voucherDateRef",
                                    attrs: { novalidate: "" }
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-date-picker", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.canEditVoucherInfo,
                                                      expression:
                                                        "canEditVoucherInfo"
                                                    }
                                                  ],
                                                  key: `voucher-date-${_vm.voucherDateKey}`,
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "La fecha de voucher es requerida.",
                                                    error: errors[0]
                                                  },
                                                  model: {
                                                    value: _vm.voucherDate,
                                                    callback: function($$v) {
                                                      _vm.voucherDate = $$v
                                                    },
                                                    expression: "voucherDate"
                                                  }
                                                }),
                                                !_vm.canEditVoucherInfo &&
                                                _vm.billInfo.voucherDate
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("date")(
                                                              _vm.billInfo
                                                                .voucherDate
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3606650657
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col d-flex justify-content-end" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-end p-0"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-gray-6 font-16 font-weight-normal mr-3"
                                      },
                                      [_vm._v(" Número de Pago: ")]
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "validation-observer",
                                          {
                                            ref: "paymentIdFormRef",
                                            attrs: { novalidate: "" }
                                          },
                                          [
                                            _c("validation-provider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("custom-input", {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.isOldBilling,
                                                              expression:
                                                                "isOldBilling"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "custom-input__extended mr-2",
                                                          attrs: {
                                                            "custom-error-msg":
                                                              "El número de pago es requerido.",
                                                            error: errors[0],
                                                            maxlength: "50"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paymentNumber,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.paymentNumber = $$v
                                                            },
                                                            expression:
                                                              "paymentNumber"
                                                          }
                                                        }),
                                                        _c(
                                                          "div",
                                                          [
                                                            errors[0] &&
                                                            !_vm.isOldBilling
                                                              ? _c("error", {
                                                                  staticStyle: {
                                                                    position:
                                                                      "relative",
                                                                    top:
                                                                      "1.3em",
                                                                    right: "9em"
                                                                  },
                                                                  attrs: {
                                                                    message:
                                                                      "El número de pago es requerido.",
                                                                    variant:
                                                                      "no-border"
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                2262050914
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    !_vm.isOldBilling
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal mr-5"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(
                                                    _vm.paymentNumber
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col d-flex justify-content-end align-items-center"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-gray-6 font-16 font-weight-normal mr-2"
                                  },
                                  [_vm._v(" Fecha de Pago: ")]
                                ),
                                _c(
                                  "validation-observer",
                                  {
                                    ref: "paymentDateRef",
                                    attrs: { novalidate: "" }
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-date-picker", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isOldBilling,
                                                      expression: "isOldBilling"
                                                    }
                                                  ],
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "La fecha de pago es requerida.",
                                                    error: errors[0]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.billInfo.paymentDate,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.billInfo,
                                                        "paymentDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "billInfo.paymentDate"
                                                  }
                                                }),
                                                _c(
                                                  "div",
                                                  [
                                                    errors[0] &&
                                                    !_vm.isOldBilling
                                                      ? _c("error", {
                                                          staticStyle: {
                                                            position:
                                                              "relative",
                                                            top: "1.3em",
                                                            right: "9em"
                                                          },
                                                          attrs: {
                                                            message:
                                                              "La fecha de pago es requerida.",
                                                            variant: "no-border"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1858127703
                                      )
                                    })
                                  ],
                                  1
                                ),
                                !_vm.isOldBilling
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-black font-16 font-weight-normal"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("date")(
                                                _vm.billInfo.paymentDate
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-auto d-flex align-items-end justify-content-end"
                              },
                              [
                                _vm.billInfo.voucherNumber &&
                                _vm.contractInfo.isDirectPayment
                                  ? _c("action-button", {
                                      staticClass:
                                        "d-flex justify-content-center align-items-center ml-3",
                                      attrs: {
                                        i: "fas fa-redo-alt",
                                        variant: "outline-success"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-auto d-flex align-items-end justify-content-end"
                              },
                              [
                                _vm.canSaveVoucherInfo
                                  ? _c("action-button", {
                                      staticClass: "mb-1",
                                      attrs: {
                                        i: "fas fa-save",
                                        variant: "outline-success"
                                      },
                                      on: { click: _vm.onSaveVoucherInfo }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _vm.voucherTrackingInfo &&
                            _vm.voucherTrackingInfo.voucherStatusReason
                              ? _c("error", {
                                  staticStyle: { border: "none" },
                                  attrs: {
                                    message:
                                      "<b>Razón de Cancelación: </b>" +
                                      _vm.voucherTrackingInfo
                                        .voucherStatusReason,
                                    variant: "custom-error-extended"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("hr"),
                      _vm.isPurchaseOrdersEmpty
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-12 bg-white rounded p-4 d-flex align-items-center justify-content-center"
                            },
                            [
                              _c("action-button", {
                                staticClass: "border w-40 btn",
                                attrs: {
                                  i: "fas fa-file-plus color-primary-1",
                                  text: "Presione aquí para añadir cifra"
                                },
                                on: { click: _vm.onAddNumberHandler }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.billInfo.billingPurchaseOrderNumbers, function(
                        digit,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: `payment_list_${index}`,
                            staticClass:
                              "mb-3 bg-white rounded py-3 mb-4 pl-3 mt-3"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-4 mt-1" }, [
                                _c(
                                  "div",
                                  { staticClass: "color-secondary-6 font-14" },
                                  [_vm._v(" Número de Cifra: ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "color-black font-16" },
                                  [_vm._v(" " + _vm._s(digit.fullNumber) + " ")]
                                )
                              ]),
                              _c("div", { staticClass: "col-sm mt-1" }, [
                                _c(
                                  "div",
                                  { staticClass: "color-secondary-6 font-14" },
                                  [_vm._v(" Número de línea: ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "color-black font-16" },
                                  [_vm._v(" " + _vm._s(digit.lineNumber) + " ")]
                                )
                              ]),
                              _c("div", { staticClass: "col-sm mt-1" }, [
                                _c(
                                  "div",
                                  { staticClass: "color-secondary-6 font-14" },
                                  [_vm._v(" Tipo de Cifra: ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "color-black font-16" },
                                  [_vm._v(" " + _vm._s(digit.digitType) + " ")]
                                )
                              ]),
                              _c("div", { staticClass: "col-sm mt-1" }, [
                                _c(
                                  "div",
                                  { staticClass: "color-secondary-6 font-14" },
                                  [_vm._v(" Grupo de edad: ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "color-black font-16" },
                                  [_vm._v(" " + _vm._s(digit.ageRange) + " ")]
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-sm mt-3 mt-md-1 mt-sm-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "color-secondary-6 font-14"
                                    },
                                    [_vm._v(" Monto: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "color-black font-16 font-14"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("price")(digit.amount)
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm mt-1 mr-3 mr-md-0 mr-sm-3 text-right"
                                },
                                [
                                  _vm.isApprovedStatus &&
                                  (!_vm.billInfo.voucherNumber ||
                                    _vm.hasDebtPurchaseOrderNumber)
                                    ? _c(
                                        "action-button",
                                        {
                                          attrs: {
                                            i: "fas fa-times-circle",
                                            variant:
                                              "outline-danger btn-cancel danger m-2 pr-4 mr-md-4"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteBillingDigit(
                                                digit
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" Eliminar ")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      }),
                      _vm.billInfo.addDigitForm && !_vm.billInfo.voucherNumber
                        ? _c(
                            "div",
                            {
                              staticClass: "row mt-3 bg-white rounded p-2 mx-0"
                            },
                            [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "div",
                                  { staticClass: "mb-2" },
                                  [
                                    _c(
                                      "validation-observer",
                                      {
                                        ref: "billingPaymentResultRef",
                                        attrs: { novalidate: "", tag: "form" }
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-14"
                                                },
                                                [_vm._v(" Número de Cifra: ")]
                                              ),
                                              _c("validation-provider", {
                                                attrs: { rules: "required" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function({ errors }) {
                                                        return [
                                                          _c(
                                                            "custom-drop-down",
                                                            {
                                                              staticClass:
                                                                "w-100",
                                                              attrs: {
                                                                clearable: false,
                                                                "custom-error-msg":
                                                                  "Favor seleccionar al menos una cifra de cuenta.",
                                                                error:
                                                                  errors[0],
                                                                fieldkey: "id",
                                                                fieldname:
                                                                  "name",
                                                                options:
                                                                  _vm.digitNumbers,
                                                                placeholder:
                                                                  "Seleccione"
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.onPurchaseOrderChange
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.value
                                                                    .purchaseOrderNumber,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.value,
                                                                    "purchaseOrderNumber",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "value.purchaseOrderNumber"
                                                              }
                                                            }
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  855693841
                                                )
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm mt-1 pl-5" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-14"
                                                },
                                                [_vm._v(" Número de línea: ")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-black font-16"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.lineNumber) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm mt-1 pl-5" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-14"
                                                },
                                                [_vm._v(" Tipo de Cifra: ")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-black font-16"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.digitType) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          !_vm.contractInfo.isDirectPayment
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm mt-1 pl-5"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "color-secondary-6 font-14"
                                                    },
                                                    [_vm._v(" Grupo de Edad: ")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "color-black font-16"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.billingServiceCategoryName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          !_vm.contractInfo.isDirectPayment
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm mt-3 mt-md-1 mt-sm-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "color-secondary-6 font-14"
                                                    },
                                                    [_vm._v(" Balance: ")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "color-secondary-6font-14"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("price")(
                                                              _vm.balance
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mt-3 mr-2 mt-md-1 mt-sm-3 p-md-0"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-14"
                                                },
                                                [_vm._v(" Monto: ")]
                                              ),
                                              _c("validation-provider", {
                                                attrs: { rules: "required" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function({ errors }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group mb-3"
                                                            },
                                                            [
                                                              _c(
                                                                "custom-input",
                                                                {
                                                                  staticClass:
                                                                    "custom-input__extended w-100",
                                                                  attrs: {
                                                                    "custom-error-msg":
                                                                      "",
                                                                    error:
                                                                      errors[0],
                                                                    "mask-type":
                                                                      "Money",
                                                                    "prepend-icon":
                                                                      "fa fa-dollar-sign",
                                                                    "prepend-icon-left": true,
                                                                    "prepend-icon-type":
                                                                      "success"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.value
                                                                        .amount,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.value,
                                                                        "amount",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "value.amount"
                                                                  }
                                                                }
                                                              ),
                                                              errors[0]
                                                                ? _c("error", {
                                                                    attrs: {
                                                                      message:
                                                                        "Favor de entrar el monto. (0326).",
                                                                      variant:
                                                                        "no-border"
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  4172923460
                                                )
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 mt-1 d-flex align-items-center justify-content-end p-md-0"
                                            },
                                            [
                                              _c(
                                                "action-button",
                                                {
                                                  attrs: {
                                                    i: "fas fa-times-circle",
                                                    variant:
                                                      "outline-danger btn-cancel danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.cancelBillingDigit()
                                                    }
                                                  }
                                                },
                                                [_vm._v(" Cancelar ")]
                                              ),
                                              _c(
                                                "action-button",
                                                {
                                                  attrs: {
                                                    i: "fas fa-save",
                                                    variant:
                                                      "success m-2 pl-4 pr-4"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveBillingDigit()
                                                    }
                                                  }
                                                },
                                                [_vm._v(" Guardar ")]
                                              )
                                            ],
                                            1
                                          )
                                        ]),
                                        !_vm.isValidAmountForGrant &&
                                        !_vm.hasDebtPurchaseOrderNumber
                                          ? _c("error", {
                                              staticClass: "pt-2 ml-2",
                                              attrs: {
                                                "is-alert-mode": "",
                                                message:
                                                  "El monto ingresado supera el disponible en el detalle de la factura para este grupo. Te recomendamos verificar e ingresar un monto válido."
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.billInfo.billingPurchaseOrderNumbers.length > 0 &&
                      !_vm.billInfo.addDigitForm &&
                      _vm.isApprovedStatus &&
                      !_vm.billInfo.voucherNumber
                        ? _c(
                            "div",
                            { staticClass: "text-right mt-2" },
                            [
                              _c("action-button", {
                                staticClass: "mr-md-4",
                                attrs: {
                                  i: "fas fa-file-plus",
                                  text: "Añadir Cifra",
                                  variant: "outline-success px-3"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openNewDigitForm()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.voucherTrackingInfo && !_vm.isApprovedStatus
                        ? _c(
                            "div",
                            { staticClass: "mt-4 bg-gray-9 rounded p-3" },
                            [
                              _c("voucher-and-payment-status-info", {
                                attrs: { info: _vm.voucherTrackingInfo }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._t("documents", null, null, {
                        hasPurchaseOrders: _vm.hasPurchaseOrders
                      })
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm.onlyShowVoucher
            ? _c(
                "div",
                { staticClass: "row mb-3 bg-secondary-13 py-3 ml-2 rounded" },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col d-flex align-items-center" },
                        [
                          _vm._m(2),
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-gray-6 font-16 font-weight-normal mr-2"
                            },
                            [_vm._v(" Número de Cheque: ")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(_vm.billInfo.checkNumber)
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "col d-flex align-items-center" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-gray-6 font-16 font-weight-normal mr-2"
                            },
                            [_vm._v(" Voucher ID: ")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(_vm.billInfo.voucherNumber)
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-green font-14 mr-3" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-usd-square fa-stack-1x fa-inverse" })
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-green font-14 mr-3" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-usd-square fa-stack-1x fa-inverse" })
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-green font-14 mr-3" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-usd-square fa-stack-1x fa-inverse" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }